import { useEffect, useState } from 'react';
import { getReferralCodeStatus } from '../services/referralCodeService';
import { convertQueryStringToJson } from '../utility/stringHelper';

const initReferralCodeStatus = {
  isReferralCodeValid: false,
  referralCodeOwner: '',
};

const useReferralCode = (search, cb) => {
  const queryParams = convertQueryStringToJson(search || '');
  const referralCode = queryParams.code;
  const [referralCodeStatus, setReferralCodeStatus] = useState(
    initReferralCodeStatus
  );

  useEffect(() => {
    if (referralCode) {
      const fetchReferralCode = async () => {
        const { error, data } = await getReferralCodeStatus(referralCode);
        if (error || !data.isReferralCodeValid) {
          // No requirement for rendering it atm.
          console.error(error?.message);
        } else {
          setReferralCodeStatus(data);
          cb(`/?code=${referralCode}`);
        }
      };

      fetchReferralCode();
    }
  }, [referralCode, cb]);

  return { ...referralCodeStatus, referralCode };
};

export default useReferralCode;
